import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Category - Get All (Read)
export const GetAll = createAsyncThunk(
  "masters/broadcast_notification/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.BroadcastNotification?.notification}?name=${filter?.name ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get (Read)
export const GetSingle = createAsyncThunk(
  "masters/broadcast_notification/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.BroadcastNotification?.notification}/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Create (Add)
export const Create = createAsyncThunk(
  "masters/broadcast_notification/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.BroadcastNotification?.notification, data);
      return res; // The new Category object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Update
export const Update = createAsyncThunk(
  "masters/broadcast_notification/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.BroadcastNotification?.notification}/${id}`,
        data
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Delete
export const Delete = createAsyncThunk(
  "masters/broadcast_notification/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(
        `${APIS.BroadcastNotification?.notification}/${id}`
      );
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Status
export const StatusBroadcastNotification = createAsyncThunk(
  "masters/broadcast_notification/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.BroadcastNotification?.notification}/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const sendNotification = createAsyncThunk(
  "masters/broadcast_notification/send-notification",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.BroadcastNotification?.notification}/send-notification/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "category",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (category) => category.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (category) => category.id !== action.payload.id
        ); // Remove the Category with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusBroadcastNotification.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusBroadcastNotification.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (category) => category.id !== action.payload.id
        ); // Remove the category with the deleted id
      })
      .addCase(StatusBroadcastNotification.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(sendNotification.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (category) => category.id !== action.payload.id
        ); // Remove the category with the deleted id
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
